export default __webpack_public_path__ + "static/066-e8c2b5479530add64f68bf17d9ce79df.jpg";